import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import { actions as coreActions, selectors as coreSelectors, hooks as coreHooks } from 'mage-core';
import { translator } from 'mage-i18n';
import { BorderlessDropdown } from '@klarna/bubble-ui';
import { analytics } from 'moet-core';

import { selectMid } from '@/actions/midSelector';
import { getSelectableMerchants } from '@/selectors/merchant';
import { isFetchingMerchant, isFetchingProducts } from '@/selectors/loadingStates';

const tPrefix = 'products-fe.containers.mid-selector';

const MidSelector = ({ dispatchSelectMid, mid, isLoading, selectableMerchants, setMid, t }) => {
  const tokenHelper = coreHooks.useTokenHelper();

  // For widget flows, there is no tokenhelper
  if (!tokenHelper) {
    return <></>;
  }

  // Enrich the list of mids on the token with the store name
  const options = tokenHelper.getMidsForClient('products-fe').map(mid => {
    const m = selectableMerchants?.find(m => mid === m.id);
    return {
      key: mid,
      label: `${mid}${m?.businessDetails?.storeName ? ` (${m?.businessDetails?.storeName})` : ''}`,
    };
  });

  const selectMerchant = mid => {
    if (mid) {
      setMid(mid);
      analytics.login({ customerid: mid });
      setTimeout(() => {
        dispatchSelectMid(mid);
      }, 1);
    }
  };

  // If the selector contains only one mid, no need to render it
  if (!options || options.length <= 1) {
    return <></>;
  }

  return (
    <div style={{ width: '50%' }}>
      <BorderlessDropdown
        tabIndex={0}
        value={mid}
        label={t(`${tPrefix}.mid-selector`)}
        options={options}
        loading={isLoading}
        disabled={isLoading}
        onChange={selectMerchant}
      />
    </div>
  );
};

MidSelector.propTypes = {
  dispatchSelectMid: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  selectableMerchants: PropTypes.array.isRequired,
  setMid: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  mid: PropTypes.string,
};

export default compose(
  connect(
    state => ({
      basePath: `/${coreSelectors.slug(state)}`,
      mid: coreSelectors.getSelectedMid(state),
      selectableMerchants: getSelectableMerchants(state),
      isLoading: isFetchingMerchant(state) || isFetchingProducts(state),
      t: translator(state),
    }),
    dispatch => ({
      dispatchSelectMid: mid => dispatch(selectMid(mid)),
      setMid: mid => dispatch(coreActions.mid.set(mid)),
    }),
  ),
)(MidSelector);
